import { CheckCircle, List, Trash2 } from 'lucide-react'

/**
 * Record status filter for soft-delete filtering across all table views.
 * - 'active': Show only non-deleted records (default)
 * - 'all': Show all records regardless of deletion status
 * - 'deleted': Show only soft-deleted records
 */
export type RecordStatusFilter = 'active' | 'all' | 'deleted'

export const RECORD_STATUS_OPTIONS: {
  value: RecordStatusFilter
  label: string
  icon: typeof CheckCircle
}[] = [
  { value: 'active', label: 'Active', icon: CheckCircle },
  { value: 'all', label: 'All Records', icon: List },
  { value: 'deleted', label: 'Deleted', icon: Trash2 },
]

export const RECORD_STATUS_LABELS: Record<RecordStatusFilter, string> = {
  active: 'Active',
  all: 'All Records',
  deleted: 'Deleted',
}
